import React from "react";
import {
  StudentChart,
  InviteChart,
  DateRangePicker,
  SideMenu,
  BackHeader,
} from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
const ClassHistoryAnalytics = (props) => {
  const navigate = useNavigate();
  const TableData = [
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },

    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="analytics-graph-main">
          <div className="graph-filter-main">
            <p className="analytics-graph-heading">
              How many students attended this class
            </p>
            <div className="analytics-graph-filter-header">
              <p className="analytics-graph-header-date">Jan-2022</p>
              <select className="analytics-graph-filter-dropdown">
                <option value="Monthly">Monthly</option>
                <option value="Weekely">Weekely</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>
          <StudentChart />
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">
                    How many students were invited?
                  </p>
                  <div className="analytics-graph-filter-header">
                    <p className="analytics-graph-header-date">Jan-2022</p>
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <InviteChart />
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <br />

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by student name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by student name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Country</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Country"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="analytics-graph-header">
                <p className="analytics-graph-header-date">Jan-2022</p>
                <select className="analytics-graph-filter-dropdown">
                  <option value="Monthly">Monthly</option>
                  <option value="Weekely">Weekely</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>
            </Grid>
          </Grid>
        </Box>

        <br />

        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="analytics-class-history-table-id-heading">ID</th>
                <th className="analytics-class-history-table-date-heading">
                  date
                </th>
                <th className="analytics-class-history-table-student-invited-heading">
                  Total student Invited
                </th>
                <th className="analytics-class-history-table-class-title-heading">
                  Class title
                </th>
                <th className="analytics-class-history-table-duration-heading">
                  duration
                </th>
                <th className="analytics-class-history-table-branch-heading">
                  branch
                </th>
                <th className="analytics-class-history-table-price-heading">
                  price
                </th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-center-data">500</td>
                    <td className="table-data">Web & Mobile App Development</td>
                    <td className="table-data">6 Months</td>
                    <td className="table-data">Mithi Tharparkar,Sindh</td>
                    <td className="table-center-data">$5000</td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default ClassHistoryAnalytics;
